import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LeftArrowLightIcon from "../../img/svg/Left_arrow_light.svg";
import VectorIcon from "../../img/svg/Vector.svg";
import { isPartnerOvdimBari } from "../../store/partnerStore";

const MultipleEntryPassWidget = ({ pass, index, array, onClick, isNew }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isHaveCard = useSelector((state) => state.userSlice.isHaveCreditCard);
  const isOvdimBari = useSelector(isPartnerOvdimBari);

  const handleClick = () => {
    navigate(isHaveCard ? "/multipleEntryPassPurchase" : "/addCard");
  };

  return (
    <div className="widget" style={isNew ? { padding: "" } : { padding: "1rem" }}>
      {isNew && (
        <div className="widget__item__ellipse">
          <span className="widget__item__ellipse__text">{t("NEW")}</span>
        </div>
      )}
      <div
        className="widget__item"
        onClick={isNew ? handleClick : null}
        style={isNew ? { cursor: "pointer" } : { cursor: "default" }}
      >
        <img
          src={isNew ? LeftArrowLightIcon : VectorIcon}
          alt="Arrow"
          className={isNew ? "multiple-entry-pass__arrow" : ""}
        />
        <div>
          <Typography className="widget__item__title">{isNew ? t("MULTIPLE_ENTRY_PASS_REWARDS") : ""}</Typography>
          <Typography className="widget__item__description">
            {isNew
              ? t(
                  isOvdimBari
                    ? "MULTIPLE_ENTRY_PASS_REWARDS_DESCRIPTION_OVDIM_BARI"
                    : "MULTIPLE_ENTRY_PASS_REWARDS_DESCRIPTION",
                )
              : t("PAYMENT_MULTIPLE_ENTRY_PASS_ALREADY_EXISTS_DESCRIPTION")}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default MultipleEntryPassWidget;
